import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Button, Image, Col, Row, Modal, Table } from 'react-bootstrap';
import moment from 'moment';
import SimpleReactLightbox from 'simple-react-lightbox';
import { SRLWrapper } from 'simple-react-lightbox';
import ReadMore from '../../../reusableComponents/ReadMore';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import SuperAdminDeleteEvent from '../../../superAdminComponents/superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteEvent';
import isEmpty from '../../../../store/validation/is-Empty';
import { amApi } from '../../../../api/apiHelper';

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: 'linear',
    overlayColor: 'rgba(0, 0, 0, 0.9)',
    slideAnimationType: 'fade',
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: 'linear',
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const ViewExpDetails = ({ id, ...props }) => {
  const history = useHistory();
  const [exp, setExp] = useState({});

  useEffect(() => {
    async function fetchData() {
      let expData = await amApi.get(`/experience/${id}`);
      setExp(expData?.data);
    }
    fetchData();
  }, []);

  console.log(exp);

  const [showMoreDetail, setShowMoreDetail] = useState(false);
  const [selectedTab, setSelectedTab] = useState('1');
  const [showView, setShowView] = useState(false);
  const handleShowMoreDetail = () => {
    setShowMoreDetail({
      showMoreDetail: !showMoreDetail.showMoreDetail,
    });
  };
  const handleShowView = () => {
    setShowView(true);
  };
  const handleCloseView = () => setShowView(false);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    console.log('test');
  };
  const [showLog, setShowLog] = useState(false);
  const handleShowLog = () => {
    setShowLog({
      showLog: !showLog.showLog,
    });
  };
  const onHandleRedirect = (data) => (e) => {
    history.push({
      pathname: `/event/edit-offline-event`,
      state: { editData: data },
    });
  };

  const expclassification = (data) => {
    let newArr = [];
    for (let i of data) {
      newArr.push(i?.title);
    }
    let values = newArr?.join(' | ');
    return values;
  };

  return (
    <>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowView}
      >
        <Image
          src={require('../../../../assets/images/UserManagement/eye.svg')}
          alt="View"
          title="View"
          fluid
        />
      </Button>
      <Modal show={showView} onHide={handleCloseView} centered size="lg">
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Experience Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="enTabs d-flex flex-wrap align-items-center mb-4 mb-2">
            <Button
              variant="link"
              onClick={(e) => handleTab('1')}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === '1' ? 'active' : ''
              }`}
            >
              General Information
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab('3')}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === '3' ? 'active' : ''
              }`}
            >
              Ticket Booking
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab('5')}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === '5' ? 'active' : ''
              }`}
            >
              Other Settings
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab('6')}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === '6' ? 'active' : ''
              }`}
            >
              Menu's
            </Button>
            <Button
              variant="link"
              onClick={(e) => handleTab('7')}
              className={`px-0 mr-4 text-grayLink f15-500 ${
                selectedTab === '7' ? 'active' : ''
              }`}
            >
              order settings
            </Button>
          </div>
          {selectedTab === '1' && (
            <React.Fragment>
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Category</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">{exp?.category?.title}</div>
                    {/* <Toggle
                      checked={props.vendorEvent && props.vendorEvent.active}
                      toggleFunction={toggleFunction}
                    /> */}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Sub-Category</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {exp?.subCategory?.title}
                    </div>
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Classification</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {expclassification(exp?.classification || [])}
                      {/* {exp?.subCategory?.title} */}
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="pt-3 d-flex justify-content-between">
                <div>
                  <div className="f12-400 opacity5">Experience Name</div>
                  <div className="d-flex align-items-center pt-2">
                    <div className="f16-500">{exp?.name}</div>
                  </div>
                </div>
                {/* <div className="d-flex align-items-center">
                  <div
                    className="enIconBtn mr-3"
                  // onClick={onHandleRedirect(props.vendorEvent)}
                  >
                    {/* <Image
                      src={require("../../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    /> 
                  </div>
                 <SuperAdminDeleteEvent
                    handleCloseView={handleCloseView}
                    actionBy={"vendor"}
                    insideDelete={"viewDelete"}
                  // eventId={props.vendorEvent && props.vendorEvent._id}
                  /> 
                </div> */}
              </div>
              <div className="pt-4 f12-400 opacity5">Description</div>
              <div className="pt-2 f12-400 text-break">{exp?.description}</div>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Status</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {exp?.active ? 'Active' : 'Inactive'}
                    </div>
                    {/* <Toggle
                      checked={props.vendorEvent && props.vendorEvent.active}
                      toggleFunction={toggleFunction}
                    /> */}
                  </div>
                </Col>
                {/* <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Primary</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {exp?.primary
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                </Col> */}
              </Row>
              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Kids Allowed</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {!exp?.ageRestriction ? 'Yes' : 'No'}
                    </div>
                  </div>
                  {/* {exp?.ageRestriction ? (
                    <></>
                  ) : (
                    <div className="f12-500 mr-2">
                      Min Age: {exp?.minAge}
                    </div>
                  )} */}
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Experience Tags</div>
                  <div className="f16-700">
                    {!isEmpty(exp?.tags) &&
                      exp?.tags.map((data, index) => {
                        return (
                          <React.Fragment key={index}>{data}, </React.Fragment>
                        );
                      })}
                  </div>
                </Col>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Added Food Items</div>
                  <div className="f16-700">{exp?.foodItems || 'N/A'}</div>
                </Col>
              </Row>

              <hr />
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require('../../../../assets/images/UserManagement/calendar.svg')}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {moment(exp?.startDate).format('DD/MM/YYYY')}
                    </div>
                  </div>
                </Col>
                {/* <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Start Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(
                        exp?.startTime
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col> */}
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">End Date</div>
                  <div className="d-flex align-items-center">
                    <Image
                      src={require('../../../../assets/images/UserManagement/calendar.svg')}
                      alt="View"
                      title="View"
                      width="20px"
                      className="mr-2"
                    />
                    <div className="f16-700">
                      {moment(exp?.endDate).format('DD/MM/YYYY')}
                    </div>
                  </div>
                </Col>
                {/* <Col lg={3} md={6} className="my-3">
                  <div className="pb-2 f12-400 opacity5">End Time</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-700">
                      {moment(
                        exp?.endTime
                      ).format("hh:mm A")}
                    </div>
                  </div>
                </Col> */}
              </Row>
              <hr />
              <div className="pt-4 f12-400 opacity5">
                Venue /Address / Location
              </div>
              <div className="pt-2 pb-4 f12-400 text-break">
                {exp?.venueAddress}
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">
                  View Experience Image
                </div>
                {/* <div className="enIMG105"></div> */}
                <div className="d-flex flex-wrap">
                  <SimpleReactLightbox>
                    {(exp?.photos || []).map((url, index) => (
                      <div
                        className="enIconUploaded bg-transparent"
                        key={index}
                      >
                        <SRLWrapper options={options}>
                          <Image
                            src={url}
                            alt="Document"
                            className="rounded img-thumbnail"
                            fluid
                          />
                        </SRLWrapper>
                      </div>
                    ))}
                  </SimpleReactLightbox>
                </div>
              </div>
              <div className="pb-4">
                <div className="pb-2 f12-400 opacity5">View Video</div>
                <div className="w-25">
                  {exp?.videos?.length <= 0 ? (
                    <h5 className="f12-500">Video Not Available</h5>
                  ) : (
                    <SimpleReactLightbox>
                      <SRLWrapper options={options}>
                        <video width="100%" height="100%" controls>
                          <source src={exp?.videos?.[0]} type="video/mp4" />
                        </video>
                      </SRLWrapper>
                    </SimpleReactLightbox>
                  )}
                </div>
              </div>
              <div className="pb-4">
                <div className="f12-400 opacity5">Terms and Conditions</div>
                <div className="pt-2 f12-400 text-break">{exp?.tc}</div>
              </div>
            </React.Fragment>
          )}
          {selectedTab === '3' && (
            <React.Fragment>
              <hr />
              <div className="enTicketBox d-flex flex-wrap">
                <div className="enbox2">
                  <div className="f12-500 opacity5 pb-3">
                    Minimum seat per booking
                  </div>
                  <div className="f16-700">{exp?.minSeats}</div>
                </div>
                <div className="enbox2">
                  <div className="f12-500 opacity5 pb-3">
                    Maximum seat per booking
                  </div>
                  <div className="f16-700">{exp?.maxSeats}</div>
                </div>
                <div className="enbox2">
                  <div className="f12-500 opacity5 pb-3">
                    Total No of seats Available
                  </div>
                  <div className="f16-700">{exp?.seatsLeft}</div>
                </div>
              </div>
              <hr />

              <div className="f12-400 opacity5 pb-3">Ticket Description</div>
              <div className="f12-400 pb-4">{exp?.ticketDesc}</div>
              <hr />
              <div className="row">
                <div className="col borderRight">
                  <div className="f12-500 opacity5 pb-3 ">Experience Name</div>
                  <div className="f16-700">{exp?.name}</div>
                </div>
                <div className="col borderRight m-0">
                  <div className="f12-500 opacity5 pb-3">
                    Adult Ticket Price
                  </div>
                  <div className="f16-700">{exp?.adultPrice}</div>
                </div>
                {!exp?.ageRestriction ? (
                  <div className="col-3">
                    <div className="f12-500 opacity5 pb-3">
                      Kids Ticket Price
                    </div>
                    <div className="f16-700">{exp?.kidsPrice}</div>
                  </div>
                ) : null}
                <div className="col">
                  <div className="f12-500 opacity5 pb-3">Add Ons</div>
                  <div className="f16-700">
                    <ReadMoreReact
                      text={exp?.addOnDesc}
                      min={0}
                      ideal={0}
                      max={exp?.addOnDesc.length}
                      readMoreText={'Read More'}
                    />
                    {/* {exp?.addOnDesc || "N/A"} */}
                  </div>
                </div>
              </div>
              <hr />
              {exp?.packages?.length > 0 ? (
                <>
                  {exp?.packages?.map((data) => {
                    return (
                      <>
                        <div>
                          <Row>
                            <Col md={3} className="borderRight m-0">
                              <div className="f12-400 opacity5 pb-3">
                                Package Name
                              </div>
                              <div className="f16-700 pb-4">{data?.name}</div>
                            </Col>
                            <Col md={3} className="borderRight m-0">
                              <div className="f12-400 opacity5 pb-3">
                                Package Price
                              </div>
                              <div className="f16-700 pb-4">{data?.price}</div>
                            </Col>
                            <Col md={3}>
                              <div className="f12-400 opacity5 pb-3">
                                Discounted Price
                              </div>
                              <div className="f16-700 pb-4">
                                {data?.discountedPrice}
                              </div>
                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <Col md={3} className="borderRight m-0">
                              <div className="f12-400 opacity5 pb-3 ">
                                No of Adults
                              </div>
                              <div className="f16-700 pb-4">{data?.adults}</div>
                            </Col>
                            <Col md={3} className="borderRight m-0">
                              <div className="f12-400 opacity5 pb-3 ">
                                No of Kids
                              </div>
                              <div className="f16-700 pb-4">{data?.kids}</div>
                            </Col>
                            <Col md={3} className="borderRight m-0">
                              <div className="f12-400 opacity5 pb-3 ">
                                Can number of <br /> seats be customized ?
                              </div>
                              <div className="f16-700 pb-4">
                                {data?.seatCustomized ? 'Yes' : 'No'}
                              </div>
                            </Col>
                            <Col md={3}>
                              <div className="f12-400 opacity5 pb-3">
                                Can experience <br /> be rescheduled?
                              </div>
                              <div className="f16-700 pb-4">
                                {exp?.rescheduleAllowed ? 'Yes' : 'No'}
                              </div>
                            </Col>
                          </Row>
                          <hr />
                          <Row>
                            <div className="col-12">
                              <div className="f12-400 opacity5 pb-3">
                                Package Description
                              </div>
                              <div className="f12-400 pb-4">{data?.desc}</div>
                            </div>
                          </Row>
                        </div>
                      </>
                    );
                  })}
                </>
              ) : null}
              <hr />
              <div className="f12-400 opacity5 pb-3">Refund & cancellation</div>
              <div className="f12-400 pb-4">{exp?.refundDesc}</div>
            </React.Fragment>
          )}
          {selectedTab === '5' && (
            <React.Fragment>
              <hr />
              <Row>
                <Col lg={12}>
                  <div className="enTicketBox d-flex flex-wrap justify-content-between">
                    <div className="col-10">
                      <div className="row">
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">Highchair</div>
                          <div className="f16-700">
                            {!exp?.ageRestriction && exp?.highchairAccess
                              ? 'Yes'
                              : 'No'}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">
                            Handicap Access
                          </div>
                          <div className="f16-700">
                            {exp?.handicapAccess ? 'Yes' : 'No'}
                          </div>
                        </div>
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">
                            Room number on Seating Request
                          </div>
                          <div className="f16-700">No</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="d-flex justify-content-end align-items-center">
                        {/* <div
                          className="enIconBtn mr-3"
                          onClick={onHandleRedirect(props.vendorEvent)}
                         
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div> */}
                        {/* <SuperAdminDeleteEvent
                          handleCloseView={handleCloseView}
                          actionBy={"vendor"}
                          insideDelete={"viewDelete"}
                          eventId={props.vendorEvent && props.vendorEvent._id}
                        /> */}
                      </div>
                    </div>
                  </div>
                </Col>
                <hr />
                <Col lg={12}>
                  <div className="enTicketBox d-flex flex-wrap justify-content-between">
                    <div className="col-10">
                      <div className="row">
                        <div className="col-3">
                          <div className="f12-500 opacity5 pb-3">
                            *Auto Accept Pax Limit
                          </div>
                          <div className="f16-700">{exp?.autoAcceptPax}</div>
                        </div>
                        {exp?.expType === 'SPECIAL' && (
                          <>
                            <div className="col-3">
                              <div className="f12-500 opacity5 pb-3">
                                Maximum Days Ahead
                              </div>
                              <div className="f16-700">{exp?.maxDaysAhead}</div>
                            </div>
                            <div className="col-3">
                              <div className="f12-500 opacity5 pb-3">
                                Booking time slot
                              </div>
                              <div className="f16-700">
                                {exp?.bookingTimeSlot}
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="col-2">
                      <div className="d-flex justify-content-end align-items-center">
                        {/* <div
                          className="enIconBtn mr-3"
                          onClick={onHandleRedirect(props.vendorEvent)}
                         
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/pencil.svg")}
                            alt="Edit"
                            title="Edit"
                            fluid
                          />
                        </div> */}
                        {/* <SuperAdminDeleteEvent
                          handleCloseView={handleCloseView}
                          actionBy={"vendor"}
                          insideDelete={"viewDelete"}
                          eventId={props.vendorEvent && props.vendorEvent._id}
                        /> */}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedTab === '6' && (
            <>
              {exp?.menuList.length
                ? exp?.menuList.map((item, index) => (
                    <div className="d-flex align-items-center mb-4" key={index}>
                      <div className="border p-2 d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-center">
                          <div className="f14-500 px-3">{item?.name}</div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="f14-500 pr-3">
                            {item?.description}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : 'No menus attached to this experience.'}
              <div className="my-2 f12-500"></div>
            </>
          )}
          {selectedTab === '7' && (
            <>
              <Row>
                <Col lg={3} md={6} className="my-3 border-right">
                  <div className="pb-2 f12-400 opacity5">Order Types</div>
                  <div className="d-flex align-items-center">
                    <div className="f16-500 mr-2">
                      {exp?.orderType?.includes('DINEIN') ? 'Dine in' : ''}
                      {exp?.orderType?.includes('DELIVERY') ? ' Delivery' : ''}
                    </div>
                  </div>
                </Col>
                {exp?.orderType?.includes('DELIVERY') ? (
                  <>
                    <Col lg={3} md={6} className="my-3 border-right">
                      <div className="pb-2 f12-400 opacity5">
                        Packaging Charges
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="f16-500 mr-2">
                          {exp?.packaging_charges || 0}
                        </div>
                      </div>
                    </Col>
                  </>
                ) : null}
              </Row>
            </>
          )}
          <hr />
          <div>
            <Button
              variant="link"
              onClick={handleShowMoreDetail}
              className="f18-700 px-0 pb-3 text-dark"
            >
              View more details{' '}
              <Image
                src={require('../../../../assets/images/UserManagement/up-arrow.svg')}
                alt="offer"
                title="offer"
                fluid
                width="15px"
                className={`ml-2 ${
                  !showMoreDetail.showMoreDetail ? 'en180deg' : ''
                }`}
              />
            </Button>
          </div>
          {showMoreDetail.showMoreDetail && (
            <div className="enGrayBorderBox">
              <Row className="px-4">
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Experience ID</div>
                  <div className="f14-400">#{exp?.expId}</div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Changed Date / Time</div>
                  <div className="f14-400">
                    {moment(exp?.updatedAt).format('Do MMMM YYYY')}
                  </div>
                  <div className="f14-400">
                    {moment(exp?.updatedAt).format('hh:mm A')}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Created Date / Time</div>
                  <div className="f14-400">
                    {' '}
                    {moment(exp?.createdAt).format('Do MMMM YYYY')}
                  </div>
                  <div className="f14-400">
                    {moment(exp?.createdAt).format('hh:mm A')}
                  </div>
                </Col>
                <Col lg={3} md={6} className="py-3">
                  <div className="f12-500 pb-3">Point of Entry</div>
                  <div className="f14-400">
                    {/* {props.vendorEvent && props.vendorEvent.point_of_entry} */}
                    Manually Added
                  </div>
                </Col>
              </Row>
            </div>
          )}
          <hr />
          <Button
            variant="link"
            onClick={handleShowLog}
            className="f18-700 px-0 pb-3 text-dark"
          >
            View Audit Log{' '}
            <Image
              src={require('../../../../assets/images/UserManagement/up-arrow.svg')}
              alt="offer"
              title="offer"
              fluid
              width="15px"
              className={`ml-2 ${!showLog.showLog ? 'en180deg' : ''}`}
            />
          </Button>
          {showLog.showLog && (
            <div className="enGrayBorderBox">
              <Table responsive className="enAuditLogTBL">
                <thead>
                  <tr>
                    <th className="">
                      <div className="f12-500">Date</div>
                    </th>
                    <th>
                      <div className="f12-500">Operation</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {(exp?.auditLogs || []).map((data, index) => (
                    <tr key={index}>
                      <td>
                        <div className="f12-500">
                          {moment(data.timestamp).format('Do MMMM YYYY')}
                        </div>
                        <div className="f12-500">
                          {moment(data.timestamp).format('hh:mm A')}
                        </div>
                      </td>
                      <td>
                        <div className="f12-500">{data.message}</div>
                      </td>
                      <td>
                        <div className="f12-500">
                          {data.initiator === 'VENDOR' ? 'You' : data.initiator}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewExpDetails;
